import { Deserializable } from '../../protocols/deserializable';
import { Address } from './address';
import { PhoneNumberUtils } from '../../../utils/phone-number-utils';

export class Spouse implements Deserializable {
  public id!: number;
  public firstName!: string;
  public middleName?: string;
  public lastName!: string;
  public socialInsuranceNumber!: string;
  public email!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public birthDate!: string;
  public address!: Address;
  public effectiveDate!: string;
  public endDate?: string;

  // Not from API
  public formattedPhoneNumber!: string;

  onDeserialize(): void {
    if (!!this.address) {
      this.address = window?.injector?.Deserialize?.instanceOf(Address, this.address);
    }
    if (this.phoneNumber) {
      this.formattedPhoneNumber = PhoneNumberUtils.formatPhoneNumberToDashed(this.phoneNumber);
    }
  }
}
